import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ad69aca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad69aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad69aca')) {
      api.createRecord('3ad69aca', component.options)
    } else {
      api.reload('3ad69aca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ad69aca&scoped=true", function () {
      api.rerender('3ad69aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYRichLocalEditor/index.vue"
export default component.exports